import { api, FormatResponse } from '../index';
const BASE_ENDPOINT ='/api/v1/workflows/create-quickbooks-webhook-id';

export const createQuickbooksWebhookId = async (workflowId) => {
        const webhookIdRes = await api.patch(`${BASE_ENDPOINT}/${workflowId}`);
        return new FormatResponse(webhookIdRes);
};